export const getNameInitials = (name) => {
  const [fName, lName] = name.split(' ');
  return `${fName[0]}${lName[0]}`;
};
